(function ($) {
  /**
   * skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
   */
  $(".skip-link").click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  // TOT CLICABLE
  $(".clic").on("click", function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });

  /**
   * TAB PÀGINA D'INICI
   * Pel disseny necessito aplicar la classe is-visible a les
   * imatges que es troben fora de js-tabcontent.
   */

  //primer afegeixo la classe is-visible a la primera imatge
  $(".tab-images img:first-of-type").addClass("is-visible");

  $("#home-tabs .js-tablist__link").click(function () {
    var id = $(this).attr("id");
    var imageId = "#" + id + "-image";

    // Treu la classe "is-visible" de totes les imatges
    $('[id$="-image"]').removeClass("is-visible");

    // Aplica la classe "is-visible" a la imatge corresponent
    $(imageId).addClass("is-visible");
  });

  /**
   * Amaguem el contingut abans que es
   * faci una cerca a la pàgina de distribuidors
   */


  $('.mdf_standard_paginate').hide();

    // Escuchar el evento de búsqueda del filtro MDTF
    $('.mdf_taxonomy').on('change', function () {
      // Mostrar los resultados cuando se realice una búsqueda
      $('.mdf_standard_paginate').show();
    });


  /**
   * Scroll top
   */
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $(".scrolltop").addClass("is-visible");
    } else {
      $(".scrolltop").removeClass("is-visible");
    }
  });

  /**
   * Afegir classe a l'extracte de la descripció
   * quan fem clic a expandmore
   */
  $(".js-expandmore").on("click", function () {
    $(".extract").toggleClass("is-expanded");
  });

  /**
   * Cercador
   */
  $("#buscar").on("click", function (eta) {
    eta.preventDefault();
    var $icona = $(this).find("svg use");
    $icona.attr("href", $icona.attr("href") == "#x" ? "#search" : "#x");
    $(this).toggleClass("is-active");
    $("#search-container").toggleClass("is-visible");
  });

  /**
   * Timeline
   */

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  var items = $(".timeline li");

  function callbackFunc() {
    items.each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass("in-view");
      }
    });
  }

  $(window).on("load scroll", callbackFunc);

  /**
   * Hamburguesa navegació principal
   */
  $(".hamburger").on("click", function () {
    $(this).toggleClass("active");
    $("body").toggleClass("has-overflow");
  });

  //Treure classes amb viewport > 768 relacionades amb el menú responsive
  var $window = $(window),
    $hamb = $("button.hamburger"),
    $body = $("body");

  function res() {
    if ($window.width() > 1024) {
      $hamb.removeClass("active");
      $body.removeClass("has-overflow");
    }
  }

  $window.resize(res).trigger("resize");
})(jQuery);
("use strict");

// function isElementInViewport(el) {
//   var rect = el.getBoundingClientRect();
//   return (
//     rect.top >= 0 &&
//     rect.left >= 0 &&
//     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
//   );
// }

// var items = document.querySelectorAll(".timeline li");
// // code for the isElementInViewport function
// function callbackFunc() {
//   for (var i = 0; i < items.length; i++) {
//     if (isElementInViewport(items[i])) {
//       items[i].classList.add("in-view");
//     }
//   }
// }
// window.addEventListener("load", callbackFunc);
// window.addEventListener("scroll", callbackFunc);
